module.exports = __webpack_public_path__ + "media/apps/shopper_app_192-2ed19622.png";